import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'; 

import { getApiDatas, getReqParam } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { postApiDatas, dayRemaining, strDateToFrLong, urlToHost } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { CONST_EventTypes } from "../data/const"

import DefaultModal from './inc/Modal/DefaultModal'


class PageNCEventDesinscription extends Component {
	constructor(props) {
		super(props)
		this.state = {
			apiDatas:[],
			id:null,
		}
		this.registration = this.registration.bind(this)
	}
	componentDidMount() {
        var RegistrationEncId = getReqParam("id");
		if(RegistrationEncId !== undefined){
            this.setState({
                id: RegistrationEncId
            }); 
    
			getApiDatas(`/apiaox/Event/GetDataPageNCEventDesinscription?id=${encodeURIComponent(RegistrationEncId)}`)
			.then((apiDatas) => { this.setState({ apiDatas:apiDatas }) })
		}

		document.body.classList.add('pg_formation_detail')    //!! ne s'applique pas si MainHeader sClassForPage
		window.scrollTo(0,0);
  	}
	componentWillUnmount() {
		document.body.classList.remove('pg_formation_detail')
	}

    registration(){
        document.body.classList.add('is-loading');
        postApiDatas(`/apiaox/Event/PostNCEventDesinscription?id=${encodeURIComponent(this.state.id)}`, {})
        .then((res) => {
            document.body.classList.remove('is-loading')
            this.setState({
                formSubmitted: res.IsValid,
                apiError: !res.IsValid,
                apiErrorMsg: res.Message,
                onRegistration: false,
            })
            if(res.IsValid){
                this.ModalRegistrationDone.openModal();
            }
        });
    }

	render() {
		const apiDatas = this.state.apiDatas;
        const Event = apiDatas?.Event;
        const EventSession = apiDatas?.EventSession;
        const DayRemaining = EventSession ? dayRemaining(EventSession.EventSession_StartDate) : -1;
        const EventRegistrationEncId = this.state.id;

		return (<> { EventRegistrationEncId && Event && EventSession && <>
            <div class="obj_back-page"><br/><br/></div>

            <section className="obj_section section_formation_detail">
                <div className="ctn_section">
                    <div className="ctn_title">
                        <h1 className="t_title">{Event.Event_Title}{EventSession.EventSession_HalfDayTypeName !== "" ? (" - " + EventSession.EventSession_HalfDayTypeName) : ""}</h1>
                    </div>

                    <div className="ctn_row">
                        <div className={`obj_formation_detail
                            ${' ' + CONST_EventTypes[Event.EventType_Code].css}
                            ${' ' + Event.Brand.Brand_CssClass}
                            ${!apiDatas.UserRegistered ? ' is_registered' : '' }`
                        }>
                            <div className="ctn_row">
                                <div className="ctn_image">
                                    <div className="ctn_visuel">
                                        <img src={urlToHost(Event.Event_MediaUrl)} alt={Event.Event_MediaAlt}/>
                                    </div>

                                    <div className="ctn_logo">
                                        <img src={urlToHost(Event.Brand.Brand_LogoUrl)} alt={Event.Brand.Brand_Name}/>
                                    </div>
                                </div>

                                <div className="ctn_text">	
                                    <p className={`t_tag`}>
                                        {EventSession.EventSession_HalfDayTypeName !== "" ? "Demi-journée de formation" : EventSession.EventType_Name}
                                    </p>

                                    {apiDatas.Registered === true && (
                                        (DayRemaining > 0) ? 
                                            <div className="obj_jours-restant">J-{DayRemaining}</div>
                                        : (DayRemaining===0) ?
                                            <div className="obj_jours-restant">Aujourd'hui</div>
                                        : <></>
                                    )}

                                    <ul className="list_infos">
                                        {EventSession.EventSession_EndDate != null ?
                                            <li className="t_date">
                                                Du {strDateToFrLong(EventSession.EventSession_StartDate)} Au {strDateToFrLong(EventSession.EventSession_EndDate)}
                                            </li>
                                        :
                                            <li className="t_date">
                                                {strDateToFrLong(EventSession.EventSession_StartDate)}
                                            </li>
                                        }
                                        <li className="t_info">
                                            {Event.EventType_Code === 'WEB' ? 
                                                EventSession.EventSession_StartHour ? EventSession.EventSession_StartHour : "-"
                                            : 
                                                EventSession.Place?.EventPlace_City ? EventSession.Place.EventPlace_City : "-"
                                            }
                                        </li>
                                    </ul>

                                    <p className="t_title">{( EventSession && EventSession.EventSession_SubTitle) ? EventSession.EventSession_SubTitle : Event.Event_SubTitle}</p>
                                    <p className="t_desc" dangerouslySetInnerHTML={{__html: (EventSession && EventSession.EventSession_Description) ? EventSession.EventSession_Description : Event.Event_Description}}/>

                                    {(apiDatas.Registered === false ) &&
                                        <p className="t_inscription">vous êtes désinscrit</p>
                                    }
                                    
                                    {apiDatas.Registered && (DayRemaining > -1) && <>

                                        <div className="ctn_cta">
                                            <button className="obj_btn light" 
                                                onClick={() => {this.ModalRegistrationConfirm.openModal()}}
                                            >
                                                se désinscrire
                                            </button>
                                            <DefaultModal
                                                onRef={ref => (this.ModalRegistrationConfirm = ref)}
                                                onClose={() => window.location.reload(false)}
                                                handleAction={this.registration}
                                                titleText="Confirmation"
                                                mainText="Voulez-vous vous désinscrire à cet évènement ?"
                                                actionText="Confirmer"
                                            />

                                            <DefaultModal
                                                onRef={ref => (this.ModalRegistrationDone = ref)}
                                                onClose={() => window.location.reload(false)}
                                                htmlContent={<>
                                                    <p className="t_title">Votre Désinscription est enregistrée.</p>
                                                    <p className="t_main"></p>
                                                    <div className="ctn_cta">
                                                        <button className="obj_cta" type="button" onClick={() => this.ModalRegistrationDone.closeModal()}>fermer</button>
                                                    </div>
                                                </>}
                                            />
                                        </div>
                                        {EventSession.Place?.EventPlace_MediaUrl &&
                                            <div className="ctn_visuel_map">
                                                <img src={urlToHost(EventSession.Place.EventPlace_MediaUrl)} alt={EventSession.Place.EventPlace_MediaAlt}/>
                                            </div>
                                        }

                                    </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>}</>)
	}
}

export default withTranslation()(PageNCEventDesinscription)